// import ClazzStandardApi from '../../../api/src/course_standard/api/ClazzStandardApi'
import FragmentApi from '../../../api/src/course_standard/api/FragmentApi'
import {message} from "ant-design-vue";

// const clazzStandardApi = new ClazzStandardApi();
const fragmentApi = new FragmentApi();
const state = {
    clazzList: [],
    fragmentList: []
}

const mutations = {
    addClazzList(state, data) {
        state.clazzList = data || []
    },
    addFragmentList(state, data) {
        state.fragmentList = data || []
    },
}

const actions = {
    initClassStandard: async ({commit, state}, query = {pageNum: 1}) => {
        let res = await clazzStandardApi.findPagingClazzStandard(query.pageNum, query.companyId, query.courseId);
        res.list.map((item, key) => item.key = key)
        commit('addClazzList', res.list)
        return res
    },
    addClassStandard: async ({commit, state}, query = {}) => {
        return new Promise((resolve, reject) => {
            clazzStandardApi.addClazzStandard(query).then(res => {
                resolve(res)
            }).catch(err => {
                message.error(err.message)
            })
        })
    },
    detailClassStandard: async ({commit, state}, id) => {
        return new Promise((resolve, reject) => {
            clazzStandardApi.getClazzStandardDetail(id).then(res => {
                resolve(res)
            }).catch(err => {
                message.error(err.message)
            })
        })
    },
    putClassStandard: async ({commit}, query) => {
        return new Promise((resolve, reject) => {
            clazzStandardApi.updateClazzStandard(query.id, query.body).then(res => {
                resolve(res)
            }).catch(err => {
                message.error(err.message)
            })
        })
    },

    // 搜索碎片
    searchFragment: ({commit}, query) => {
        return new Promise((resolve, reject) => {
            fragmentApi.searchFragment(
                query.pageNum,
                query.courseStandardId,
                query.opts
            ).then(res => {
                (res.list || []).map((item, key) => item.key = key)
                commit('addFragmentList', res.list)
                resolve(res)
            }).catch(err => {
                reject(err)
                message.error(err.message)
            })
        })
    },
    // 删除碎片
    deleteFragment: ({commit}, id) => {
        return new Promise((resolve, reject) => {
            fragmentApi.deleteFragment(id).then(res => {
                resolve(res)
            }).catch(err => {
                message.error(err.message)
                reject(err)
            })
        })
    },

    // 碎片详情
    getFragment: ({commit}, id) => {
        return new Promise((resolve, reject) => {
            fragmentApi.getFragment(id).then(res => {
                resolve(res)
            }).catch(err => {
                message.error(err.message)
            })
        })
    },

    // 新增碎片附件
    addFragmentRes: ({commit}, query) => {
        return new Promise((resolve, reject) => {
            fragmentApi.addFragmentRes(query.id, query.body).then(res => {
                resolve(res)
            })
        })
    },

    // 获取oss访问令牌
    getStsAk: ({commit}, id) => {
        return new Promise((resolve, reject) => {
            fragmentApi.getStsAk(id).then(res => {
                resolve(res)
            })
        })
    },

    // 删除碎片
    deleteFragmentRes: ({commit}, query) => {
        return new Promise((resolve, reject) => {
            fragmentApi.deleteFragmentRes(query.id, query.resId).then(res => {
                resolve(res)
            })
        })
    },

    // 修改碎片
    updateFragment: ({commit}, query) => {
        return new Promise((resolve, reject) => {
            fragmentApi.updateFragment(query.id, query.body).then(res => {
                resolve(res)
            }).catch(err => {
                message.error(err.message)
            })
        })
    },

    // 添加
    addFragmentList: ({commit}, query) => {
        return new Promise((resolve, reject) => {
            fragmentApi.addFragment(query.body).then(res => {
                resolve(res)
            }).catch(err => {
                message.error(err.message)
            })
        })
    },


    // 课程统计情况
    getClazzStandardStatistics: ({commit, state}) => {
        return new Promise((resolve, reject) => {
            clazzStandardApi.getClazzStandardStatistics().then(res => {
                resolve(res)
            }).catch(err => {
                reject(err)
            })
        })
    }


}

export default {
    // namespaced: true,
    state,
    actions,
    mutations
}
